import * as actionTypes from '../../constants/actionTypes';
import { DESCENDING_ORDER } from '../../constants/users';

const initialState = {
  isLoading: false,
  error: undefined,
  sortBy: { column: 'scheduledAt', order: DESCENDING_ORDER.toLowerCase() },
};

const deviceSessions = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_DEVICES_SESSIONS_SORT_BY:
      return { ...state, sortBy: action.payload.sortBy };

    case actionTypes.CLEAR_DEVICE_SESSIONS_FILTERS:
      return initialState;

    default:
      return state;
  }
};

export default deviceSessions;
